<template>
  <div class="wpop-cover">
    <div class="wpop-wrapper cp-pay-pop">
      <i class="wpop-close" @click="$emit('close')"></i>
      <div class="wpop-wrapper__title">支付金额：{{ money }}元</div>
      <div class="wpop-wrapper__content">
        <div class="cp-pay-pop__ewm">
          <div v-if="qrImg" class="cp-pay-pop__ewm-img">
            <img :src="qrImg" />
          </div>
          <div v-else class="cp-pay-pop__ewm-null">
            <Spinner spinner="CIRCLES" />
          </div>
          <p class="cp-pay-pop__ewm-refresh">
            <a href="javascript:;" @click="refresh">刷新二维码</a>
          </p>
        </div>
        <p class="cp-pay-pop__ewm-err" :style="{ opacity: errTip ? 1 : 0 }">
          <em>*</em> <span>{{ errTip }}</span>
        </p>
        <div class="cp-pay-pop__info">
          <p class="cp-pay-pop__info-ico">
            <img src="~/assets/img/recharge/pay-ico.png" />
            <span>使用微信或支付宝扫码支付</span>
          </p>
          <p>适度娱乐&nbsp;&nbsp;&nbsp;&nbsp;理性消费</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { qrCode } from '~/services/pay'
import Spinner from '~/components/common/InfiniteLoading/Spinner'
export default {
  components: {
    Spinner
  },
  props: {
    sid: {
      type: Number,
      default: 0
    },
    gid: {
      type: Number,
      required: true
    },
    money: {
      type: Number,
      required: true
    },
    ext: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      qrImg: null,
      errTip: null,
      deliverUserId: null,
      gameId: 0,
      serverId: 0,
      roleId: 0,
      roleName: ''
    }
  },
  computed: {
    ext2() {
      return {
        game_ext: encodeURIComponent(this.ext),
        deliver_userid: this.deliverUserId,
        role_id: this.roleId || '',
        role_name: this.roleName || '',
        game_id: this.gameId,
        server_id: this.serverId,
        user_id: this.$cookies.get('userid'),
        coupon_id: '',
        broker: 'default', // 默认为default；迅雷盒子：thunder
        coupon_code: '', // 对应券码code
        xl_voucher_code: '' // 对应券码code
      }
    },
    rmb() {
      return this.money * 100
    }
  },
  created() {
    if (process.client) {
      this.getRole().then(() => this.getQrCode())
    }
  },
  beforeDestroy() {
    this.timer && clearTimeout(this.timer)
  },
  methods: {
    refresh() {
      if (this.gameId) {
        this.getQrCode()
      } else {
        this.getRole().then(() => this.getQrCode())
      }
    },
    getQrCode() {
      this.payOrder().then((data) => {
        qrCode({
          rmb: this.rmb,
          ext2: {
            ...this.ext2,
            game_order_id: data.game_order_id,
            xl_price: this.rmb
          }
        })
          .then((data) => {
            this.qrImg = data
            this.errTip = null
            this.checkOrder()
          })
          .catch(() => {
            this.qrImg = null
            this.errTip = '二维码生成失败'
          })
      })
    },
    getRole() {
      return this.$request('getRoleByGid', {
        body: {
          gid: this.gid,
          server_num: this.sid
        }
      })
        .then((data = {}) => {
          this.deliverUserId = data.user_id
          this.gameId = data.game_id
          this.serverId = data.server_id
          const item = (data.role_list || [])[0] || {}
          this.roleId = item.role_id
          this.roleName = item.role_name
        })
        .catch((err) => {
          this.errTip = err.message
          return Promise.reject(err)
        })
    },
    payOrder() {
      return this.$request('payOrder', {
        headers: {
          'Content-Type': 'application/json'
        },
        body: {
          ...this.ext2,
          num: 1,
          rmb: this.rmb
        }
      })
        .then((data = {}) => {
          this.game_orderid = data.game_order_id
          this.deliver_userid = data.deliver_userid
          return data
        })
        .catch((err) => {
          this.errTip = err.message
          this.qrImg = null
          this.timer && clearTimeout(this.timer)
        })
    },
    checkOrder() {
      this.timer && clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.$request('checkOrder', {
          body: {
            game_order_id: this.game_orderid,
            deliver_userid: this.deliver_userid
          }
        })
          .then((data = {}) => {
            if (data.status === 1) {
              this.$emit('pay-success', true)
              // this.getQrCode()
              this.qrImg = null
            } else {
              this.checkOrder()
            }
          })
          .catch(() => {
            this.checkOrder()
          })
      }, 1000)
    }
  }
}
</script>

<style lang="scss">
.cp-pay-pop {
  .wpop-wrapper__title {
    margin-bottom: 10px;
  }
  box-sizing: border-box;
  width: 350px;
  background-color: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(183, 188, 206, 0.75);
  border-radius: 4px;
  &__ewm {
    width: 115px;
    height: 141px;
    margin: 0 auto;
    overflow: hidden;
    &-img {
      height: 115px;
    }
    img {
      width: 100%;
      height: 100%;
    }
    &-err {
      font-size: 12px;
      color: #ff4848;
    }
    &-null {
      position: relative;
      color: #4e4e4e;
      height: 115px;
      line-height: 115px;
      background: url(~assets/img/recharge/code.jpg) no-repeat;
      background-color: rgba(183, 188, 206, 0.75);
      .loading-circles {
        top: 50%;
      }
    }
    &-refresh {
      padding-top: 8px;
      a {
        font-size: 12px;
        color: #7e8aa5;
        &::before {
          display: inline-block;
          vertical-align: middle;
          content: '';
          width: 14px;
          height: 14px;
          background: url(~assets/img/commen/refresh.png) no-repeat;
          margin: -2px 5px 0 0;
        }
      }
    }
  }
  &__info {
    &-ico {
      padding: 0 0 20px 0;
      img {
        vertical-align: middle;
        margin-right: 10px;
      }
    }
  }
  .wpop-wrapper__content {
    margin: 0;
  }
}
</style>
